module.exports = __webpack_public_path__ + "img/three1Green.e1eeee29.jpg";